import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Tag } from '.';

/**
 * The if-match request header
 *
 * Every endpoint that changes or deletes an existing item accepts this, so
 * it's documented in one place to keep the wording consistent
 */
export function IfMatchHeader(): ReactElement {
  return (
    <li>
      <Tag intent="warning" icon={faQuestion} show>
        optional
      </Tag>
      <code className="attribute">
        if-match
        <span className="attribute-type">string</span>
      </code>
      <span className="attribute-description">
        <p>
          The item's ETag, from the <code>etag</code> header of the response you
          last read or wrote it with.
        </p>
        <p>
          If the item has changed since then, nothing is written and we return a
          412 ("Precondition failed") response. Fetch the item again and retry.
          See{' '}
          <a href="/docs/talking-to-the-api#conditional-writes">
            conditional writes
          </a>
          .
        </p>
      </span>
    </li>
  );
}
